import styled from 'styled-components'

export const MinAmountRegulation = styled.div`
  font-size: 18px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.39;
  letter-spacing: normal;
  color: #303030;
  max-width: 750px;

  .tooltip {
    position: relative;
    top: 2px;
    left: 2px;
  }

  table {
    width: 100%;
    margin-top: 30px;
    border-spacing: 2px;
    border-collapse: separate;
    display: table;
  }

  thead > tr > th,
  tbody > tr > td {
    width: 50%;
    background: ${ (props) => props.theme.colors['hintergrund-allgemein'] };
    padding: 9px 15px 9px 15px;
    font-weight: lighter;
    vertical-align: baseline;
  }

  .table-footer {
    margin-top: 30px;

    > p {
      margin-bottom: 5px;
    }
  }
`
